import React from 'react';
import { Avatar, Box, Link, Text } from '@99designs/emu';
import { linkTo } from '@99designs/routing';
import { trackEvent } from '@99designs/tracking';
import StarRating from './StarRating';

interface CustomerRatingProps {
    customerName: string;
    rating: number;
    comment: string;
    customerId: string;
    ratingTime: string;
    contestId: string;
}

const CustomerRating = ({
    customerName,
    rating,
    comment,
    customerId,
    ratingTime,
    contestId,
}: CustomerRatingProps) => {
    return (
        <Box paddingY={'1bu'}>
            <Box>
                <StarRating rating={rating} />
            </Box>
            <Text size="size2">{comment}</Text>
            <Box paddingY="0.5bu">
                <Link
                    href={`/contests/${contestId}`}
                    target="_blank"
                    onClick={() =>
                        trackEvent('Rating CTA clicked on product details page', {
                            path: `/contests/${contestId}`,
                            type: 'viewContest',
                        })
                    }
                >
                    {__('View their logo contest')}
                </Link>
            </Box>
            <Avatar url={linkTo.userAvatar(customerId)} size="extra-small" /> {ratingTime} |{' '}
            {customerName}
        </Box>
    );
};

export default CustomerRating;
